import { getConfiguration } from "./configuration";
import { getLiveAggs } from "./getLiveAggs";
import { getPrematchAggs } from "./getPrematchAggs";

export function showMatchDesc(odd) {
    const conf = getConfiguration();
    if (conf.tod) {
        const sportRef = odd.matchData.sportRef, aggId = odd.betData.aggId;
        const agg = odd.betData.isLive ? getLiveAggs(sportRef, aggId): getPrematchAggs(sportRef, aggId);
        return agg && agg.scommesse?.[0]?.id === odd.betData.id;
    }
    return false;
}
